import React from "react";
import RegisterForm from "../../components/RegisterForm";

export default function Login() {
	return (
		<div>
			<RegisterForm />
		</div>
	);
}
